import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import type { Payment } from '@//app/api/commerce/payments/[id]/list';
import { mapPayment } from '@//utils/payments';
import { httpClientPostJson } from '../httpClient';

export const PAYMENT_CACHE_KEY = 'NEXT_PUBLIC_ECOM_URL/payment/:id';

export interface PaymentWithId extends Payment {
  generatedId: string;
}

export interface ModifyPaymentBody {
  generatedId?: string;
  branchId: string;
  downPayment: number;
  duration: number;
  residual?: number;
  financialOptionId: string;
}

export interface ModifyPaymentVariables {
  id: string;
  cacheKey?: string;
  body: ModifyPaymentBody;
}

export interface ModifyPaymentResponse {
  response: Payment;
  successful: boolean;
}

export interface ModifyPaymentResponseWithId {
  response: PaymentWithId;
  successful: boolean;
}

const useModifyPayment = (variables: ModifyPaymentVariables | undefined) => {
  const queryKey = useMemo(
    () =>
      variables
        ? [PAYMENT_CACHE_KEY, variables.id, variables.cacheKey, JSON.stringify(variables.body)]
        : [],
    [variables],
  );

  const query = useQuery<ModifyPaymentResponseWithId>({
    queryKey,
    queryFn: async () => {
      const url = `${process.env.NEXT_PUBLIC_ECOM_URL}/payment/${variables?.id}`;
      const result = await httpClientPostJson<ModifyPaymentResponse>(url, variables?.body);

      return {
        response: {
          ...mapPayment(result.response),
          generatedId: variables?.body.generatedId || '',
        },
        successful: result.successful,
      };
    },
    enabled: !!variables,
    placeholderData: (f) => f,
  });

  return query;
};
export default useModifyPayment;
